import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Code2, Copy, Check } from "lucide-react";
import { useLang } from "@/lib/i18n";

// Full transparency drawer showing the raw normalized JSON returned by the backend.
export const ProvenanceInspector = ({ report }) => {
  const { t } = useLang();
  const [copied, setCopied] = useState(false);
  const json = JSON.stringify(report, null, 2);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(json);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      /* clipboard unavailable */
    }
  };

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="outline" className="w-full gap-2" data-testid="open-provenance-btn">
          <Code2 className="h-4 w-4" />
          {t("prov.open")}
        </Button>
      </DialogTrigger>
      <DialogContent
        data-testid="provenance-inspector-modal"
        className="max-h-[85vh] max-w-2xl overflow-hidden border-border"
      >
        <DialogHeader>
          <DialogTitle className="flex items-center justify-between font-serif text-xl">
            {t("prov.title")}
            <Button size="sm" variant="ghost" onClick={copy} data-testid="copy-provenance-json-btn" className="gap-1.5">
              {copied ? <Check className="h-4 w-4 text-emerald-500" /> : <Copy className="h-4 w-4" />}
              {copied ? t("report.copied") : t("report.copy")}
            </Button>
          </DialogTitle>
        </DialogHeader>
        <pre
          data-testid="raw-geojson-view"
          className="max-h-[60vh] overflow-auto rounded-lg border border-border bg-secondary/50 p-4 font-mono text-xs leading-relaxed text-foreground"
        >
          {json}
        </pre>
      </DialogContent>
    </Dialog>
  );
};
